import { IFormattedAddress, IGetAddressAddresses } from "./address.types";

export const sanitizeGBPostcode = (postcode: string): string => {
  const withoutWhitespace = postcode.replace(/\s/g, "").toUpperCase();
  if (withoutWhitespace.length > 3) return `${withoutWhitespace.substring(0, withoutWhitespace.length - 3)} ${withoutWhitespace.substring(withoutWhitespace.length - 3)}`;
  return withoutWhitespace;
};

export const formatAddress = (address: IGetAddressAddresses, postcode: string): IFormattedAddress => {
  if (!address.line_1) {
    return {
      formattedAddress: address.formatted_address,
      address1: "",
      address2: "",
      city: address.town_or_city,
      country: address.country,
      postcode,
      phone: "",
    };
  }

  const line1 = address.line_2
    ? `${address.line_1} ${address.line_2}`
    : address.line_1;

  const line2 = address.line_3 && address.line_4
    ? `${address.line_3} ${address.line_4}`
    : address.line_3 || "";

  return {
    formattedAddress: address.formatted_address,
    address1: line1,
    address2: line2,
    city: address.town_or_city,
    country: address.country,
    postcode,
    phone: "",
  };
};
